import ColorSF2 from '../../../styles/common/ColorSF2';

export const style = {
  main: {
    height: '100%',
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  scrolledBody: {
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    tableLayout: 'fixed',
    height: '100%',
  },
  body: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  listHeader: {
    width: '100vw',
    padding: '4px 10px 4px 10px',
    backgroundColor: ColorSF2.paleBlue,
    fontWeight: 'bold',
  },
  list: isCheck => ({
    width: 130,
    backgroundColor: isCheck ? ColorSF2.skyBlue : ColorSF2.lightGray,
    margin: '5px',
  }),
  listBody: {
    width: '100%',
    paddingTop: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  mediaData: {
    position: 'relative',
    width: 120,
    height: 120,
    backgroundColor: '#000',
    textAlign: 'center',
  },
  mediaIcon: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  info: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  checkbox: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  td: {
    width: 24,
    height: 24,
  },
  checkArea: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  defaultCheckBox: {
    display: 'none',
  },
  checkboxArea: {
    width: 14,
    height: 14,
  },
  checkboxLabel: {
    width: 14,
    height: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  date: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    fontSize: 8,
    flexWrap: 'wrap',
  },
  tagsBody: {
    maxHeight: '100%',
    overflow: 'hidden',
    paddingLeft: 5,
    textAlign: 'left',
    position: 'relative',
    fontSize: 8,
  },
  tagWrapper: {
    overflow: 'hidden',
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
  },
  tag: {
    float: 'left',
  },
  greater: {
    padding: '0px 8px 0px 8px',
  },
  playCircle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 40,
    height: 40,
    zIndex: 900,
  },
};

export default style;
